import { render } from "./HeroiconsSolidZoomOut.vue?vue&type=template&id=f55748c2"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidZoomOut.vue"]])

export default __exports__